import React, { Component } from "react";
import SimplifiedLayout from "../SimplifiedLayout";
import { Grid, Col, Row, Button } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import Helmet from "react-helmet";

class AccountActivatedPage extends Component {
    render() {
        return (
            <div>
            	<Helmet title="Account Activated"/>
                <SimplifiedLayout>
                    <Grid className="text-center">
                        <Row>
                            <Col sm={12}>
                                <h1>
                                    <i
                                        className="fa fa-user-circle-o fa-3x"
                                        aria-hidden="true"
                                    />
                                </h1>
                                <h2>Account actived</h2>
                                <h4>
                                	Log in to start using Webfinery!
                                </h4>
                                <LinkContainer to="/login">
                                    <Button bsStyle="primary" name="">
                                        Log in
                                    </Button>
                                </LinkContainer>

                            </Col>
                        </Row>

                    </Grid>
                </SimplifiedLayout>
            </div>
        );
    }
}

export default AccountActivatedPage;



// WEBPACK FOOTER //
// ./src/signup/AccountActivatedPage.js